import React from 'react';
import { Sun, Moon } from 'lucide-react';
import { useTheme } from '../contexts/ThemeContext';

interface ThemeToggleProps {
  className?: string;
  size?: 'sm' | 'md' | 'lg';
}

export const ThemeToggle: React.FC<ThemeToggleProps> = ({ 
  className = '', 
  size = 'md' 
}) => {
  const { theme, toggleTheme } = useTheme();

  const sizeClasses = {
    sm: 'w-8 h-8',
    md: 'w-10 h-10',
    lg: 'w-12 h-12'
  };

  const iconSizes = {
    sm: 16,
    md: 20,
    lg: 24
  };

  return (
    <button
      onClick={toggleTheme}
      className={`
        ${sizeClasses[size]}
        relative rounded-lg
        bg-light-bg-secondary dark:bg-dark-bg-secondary
        border border-light-border dark:border-dark-border
        hover:bg-light-bg-tertiary dark:hover:bg-dark-bg-tertiary
        focus:outline-none focus:ring-2 focus:ring-primary-500
        transition-all duration-200 ease-in-out
        flex items-center justify-center
        ${className}
      `}
      aria-label={`Switch to ${theme === 'light' ? 'dark' : 'light'} mode`}
      title={`Switch to ${theme === 'light' ? 'dark' : 'light'} mode`}
    >
      <div className="relative">
        {theme === 'light' ? (
          <Sun 
            size={iconSizes[size]} 
            className="text-light-text-primary animate-fade-in" 
          />
        ) : (
          <Moon 
            size={iconSizes[size]} 
            className="text-dark-text-primary animate-fade-in" 
          />
        )}
      </div>
    </button>
  );
};